import React from 'react';
import "./FullScreenLoader.css"

const FullScreenLoader = () => {
  return (
    <div className="loader-overlay">
    <div className="loader"></div>
  </div>
  )
}

export default FullScreenLoader
